import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reject-modal__error"
}

import { ref } from 'vue';
import Select from 'primevue/select';
import Textarea from 'primevue/textarea';
import { useToast } from 'primevue/usetoast';
import AppModal from '@/components/ui/AppModal.vue';
import FormField from '@/components/ui/FormField.vue';
import { rejectPayment } from '@/services/paymentService';
import { ApiError } from '@/models/errors/ApiError';

interface Props {
    visible: boolean
    paymentId: number | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RejectPaymentModal',
  props: {
    visible: { type: Boolean },
    paymentId: {}
  },
  emits: ["update:visible", "rejected"],
  setup(__props: any, { emit: __emit }) {

/* eslint-env vue/setup-compiler-macros */
const props = __props;

const emit = __emit;

const REJECT_REASONS = [
    'Account Closed',
    'Authorization Revoked',
    'Duplicate Transaction',
    'Fraud Suspected',
    'Incorrect Amount',
    'Payment Disputed',
    'Wrong Debtor',
    'Other',
];

const reason = ref<string | null>(null);
const notes = ref('');
const saving = ref(false);
const formError = ref('');

const toast = useToast();

async function handleReject() {
    if (!props.paymentId || !reason.value) return;
    saving.value = true;
    formError.value = '';
    try {
        await rejectPayment(props.paymentId, reason.value, notes.value || undefined);
        toast.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Payment rejected successfully.',
            life: 3000,
        });
        emit('rejected', props.paymentId);
        emit('update:visible', false);
        resetForm();
    } catch (error) {
        const apiError = ApiError.from(error);
        if (apiError) {
            const data = apiError.data as { message?: string } | undefined;
            formError.value = typeof data?.message === 'string'
                ? data.message
                : 'An error occurred. Please try again.';
        } else {
            formError.value = 'An unexpected error occurred. Please try again.';
        }
    } finally {
        saving.value = false;
    }
}

function resetForm() {
    reason.value = null;
    notes.value = '';
    formError.value = '';
}

function handleCancel() {
    resetForm();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppModal, {
    visible: __props.visible,
    title: "Reject Payment",
    "action-label": "Reject Payment",
    "action-disabled": !reason.value || saving.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (emit('update:visible', $event))),
    onCancel: handleCancel,
    onAction: handleReject
  }, {
    default: _withCtx(() => [
      _createVNode(FormField, {
        id: "reject-reason",
        label: "Reject Reason",
        class: "reject-modal__reason-field",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Select), {
            id: "reject-reason",
            modelValue: reason.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reason).value = $event)),
            class: "reject-modal__reason-select",
            options: REJECT_REASONS,
            placeholder: " "
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(FormField, {
        id: "additional-notes",
        label: "Additional Notes"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Textarea), {
            id: "additional-notes",
            draggable: "false",
            modelValue: notes.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((notes).value = $event)),
            rows: "6",
            style: {"resize":"none"},
            placeholder: " "
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      (formError.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(formError.value), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "action-disabled"]))
}
}

})